<template>
    <div>
        <v-layout wrap>
            <v-flex xs12 sm12 md6 lg6 xl6>
                <gru-chart id="summary_staf_file"
                           type="bar"
                           label=""
                           query="select f.manage_id, u.full_name as 'Tên nhân viên', count(*) as 'Số lượng' from files f left join users u on f.manage_id = u.user_id where (manage_id is not null and full_name is not null AND f.status>0 AND f.status<4) group by manage_id;"
                           :label="label1"
                           label-field="Tên nhân viên"
                           index-field="Số lượng"
                           title="Số lượng Hồ sơ đang xử lý của nhân viên"
                />
            </v-flex>
            <v-flex xs12 sm12 md6 lg6 xl6>
                <gru-chart id="summary_staf_request"
                           type="bar"
                           label=""
                           query="select f.manage_id, u.full_name as 'Tên nhân viên', count(*) as 'Số lượng' from request f left join users u on f.manage_id = u.user_id where (manage_id is not null and full_name is not null AND f.status>0 AND f.status<4) group by manage_id;"
                           :label="label1"
                           label-field="Tên nhân viên"
                           index-field="Số lượng"
                           title="Số lượng Yêu cầu đang xử lý của nhân viên"
                />
            </v-flex>
        </v-layout>
        <v-layout wrap>
            <v-flex xs12 sm12 md6 lg6 xl6>
                <gru-chart id="summary_week"
                           type="pie"
                           label=""
                           query="select case when status = 1 then 'Chờ xử lý' when status = 2 then 'Đã phân công' when status = 3 then 'Đã tạo hồ sơ' when status = 4 then 'Đã hoàn thành' end as 'Trạng thái', count(*) as 'Số lượng' from request where datediff(now(),date(request_time))<=7 group by status;"
                           :label="label1"
                           label-field="Trạng thái"
                           index-field="Số lượng"
                           title="Số lượng request trong tuần theo trạng thái"
                />
            </v-flex>
            <v-flex xs12 sm12 md6 lg6 xl6>
                <gru-chart id="summary_week_status"
                           type="bar"
                           label=""
                           query="select date(request_time) as request_date, count(*) as 'sl' from request where datediff(now(),date(request_time))<=14 group by request_date"
                           :label="label1"
                           title="Số lượng request trong hai tuần"
                           label-field="request_date"
                           index-field="sl"
                />
            </v-flex>
        </v-layout>
        <v-layout wrap>
            <v-flex xs12 sm12 md6 lg6 xl6>
                <gru-chart id="summary_file_week"
                           type="bar"
                           label=""
                           query="select date(created_at) as sd, count(*) as 'số lượng' from files where datediff(now(),date(created_at))<=10000 group by sd"
                           :label="label1"
                           title="Số hồ sơ theo ngày"
                           label-field="sd"
                           index-field="số lượng"
                />
            </v-flex>
            <v-flex xs12 sm12 md6 lg6 xl6>
                <gru-chart id="summary_file_week_status"
                           type="pie"
                           label=""
                           query="select case when status = 1 then 'Chờ xử lý' when status = 4 then 'Đã gửi' else 'Đang xử lý' end as 'Trạng thái', count(*) as 'số lượng' from files where status>0 group by status"
                           :label="label1"
                           title="Số hồ sơ theo trạng thái"
                           label-field="Trạng thái"
                           index-field="số lượng"
                />
            </v-flex>
        </v-layout>
        <v-layout wrap>
            <v-flex xs12 sm12 md6 lg6 xl6>
                <gru-chart id="summary_send_email_week"
                           type="bar"
                           label=""
                           query="select date(send_date) as sd, count(*) as 'số lượng' from send_email where datediff(now(),date(send_date))<=7 group by sd"
                           :label="label1"
                           title="Số lượng email gửi đi theo ngày"
                           label-field="sd"
                           index-field="số lượng"
                />
            </v-flex>
            <v-flex xs12 sm12 md6 lg6 xl6>
                <gru-chart id="summary_send_email_week_status"
                           type="pie"
                           label=""
                           query="select case when is_send = 0 then 'Chờ xử lý' when is_send = 1 then 'Đã gửi' end as 'Trạng thái', count(*) as 'số lượng' from send_email where datediff(now(),date(send_date))<=14 group by is_send"
                           :label="label1"
                           title="Số lượng email trong tuần"
                           label-field="Trạng thái"
                           index-field="số lượng"
                />
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import GruChart from "../../components/form/GruChart";

    export default {
        components: {GruChart},
        data() {
            return {
                label1: [
                    {label: "thứ 2", color: "coral"},
                    {label: "thứ 3", color: "blue"},
                    {label: "thứ 4", color: "orange"},
                    {label: "thứ 5", color: "green"},
                    {label: "thứ 6", color: "violet"},
                    {label: "thứ 7", color: "gray"},
                    {label: "chủ nhật", color: "purple"},
                    {label: "nghỉ", color: "brown"},
                ]
            }
        },
        created() {
        },
        methods: {}
    };
</script>